import React from "react";
import {Redirect, Route, useLocation} from "react-router-dom";

import {isAuthenticated} from "../../utils/Utils";

/**
 * Guards everything behind the admin login. Rendering the layout first and
 * letting the 401 interceptor bounce the user later is what made the dashboard
 * flash before the login page; here the redirect happens before the page ever
 * mounts. The current path travels along so login can return the admin to it.
 *
 * Accepts either `children` or a `render` prop, like Route itself.
 */
export default function PrivateRoute({children, render, ...rest}) {
    const location = useLocation();

    return (
        <Route
            {...rest}
            render={(props) =>
                isAuthenticated() ? (render ? render(props) : children) : (
                    <Redirect
                        to={{
                            pathname: '/login',
                            state: {from: location.pathname + location.search},
                        }}
                    />
                )
            }
        />
    );
}
